// extracted by mini-css-extract-plugin
module.exports = {"rightAlignedSort":"GroupAdmin_rightAlignedSort__3NG2X","totalGroups":"GroupAdmin_totalGroups__2yrgh"};